import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Brand } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, ShieldCheck } from "lucide-react";

export default function Setup() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    api.get("/auth/setup-status").then((r) => {
      if (!r.data.needs_setup) { nav("/login", { replace: true }); return; }
      setEmail(r.data.email); setChecking(false);
    }).catch(() => setChecking(false));
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { setErr("Şifre en az 8 karakter olmalıdır"); return; }
    if (pw !== pw2) { setErr("Şifreler eşleşmiyor"); return; }
    setLoading(true); setErr("");
    try {
      const r = await api.post("/auth/setup-admin", { password: pw });
      localStorage.setItem("token", r.data.token);
      const me = await api.get("/auth/me");
      setUser(me.data);
      nav("/admin", { replace: true });
    } catch (e2) { setErr(apiError(e2.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  if (checking) return <div className="flex min-h-screen items-center justify-center bg-[#f8fafc]"><Loader2 className="h-8 w-8 animate-spin text-emerald-600" /></div>;

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f8fafc] p-6">
      <form onSubmit={submit} className="fade-in w-full max-w-md" data-testid="setup-form">
        <div className="mb-8"><Brand /></div>
        <div className="mb-4 flex items-center gap-2 rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-800">
          <ShieldCheck className="h-5 w-5" /> İlk kurulum: yönetici hesabı için güvenli bir şifre belirleyin.
        </div>
        <h2 className="font-heading text-2xl font-bold text-[#0a192f]">Yönetici Şifresi Belirle</h2>
        <p className="mt-1 text-sm text-slate-500">{email}</p>
        {err && <div data-testid="setup-error" className="mt-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">{err}</div>}
        <div className="mt-6 space-y-4">
          <div><Label>Yeni Şifre (en az 8 karakter)</Label><Input type="password" required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} data-testid="setup-password-input" className="mt-1.5" /></div>
          <div><Label>Şifre (Tekrar)</Label><Input type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="setup-password-confirm-input" className="mt-1.5" /></div>
        </div>
        <Button type="submit" disabled={loading} data-testid="setup-submit-button" className="mt-6 w-full bg-emerald-600 hover:bg-emerald-700">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Şifreyi Belirle ve Giriş Yap"}
        </Button>
      </form>
    </div>
  );
}
